import React, { useState } from 'react';

import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Box, Collapse, Link, Typography } from '@mui/material';

interface Props {
  names: Array<string>;
}

export default function DealOptionsDisclosure({ names }: Props) {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <>
      <Link
        component="button"
        type="button"
        variant="caption"
        color="text.secondary"
        underline="hover"
        aria-expanded={isExpanded}
        onClick={() => setIsExpanded((current) => !current)}
        sx={{ alignItems: 'center', alignSelf: 'flex-start', display: 'inline-flex' }}
      >
        Used by {names.length} deal option{names.length === 1 ? '' : 's'}
        {isExpanded ? <ExpandLessIcon fontSize="inherit" /> : <ExpandMoreIcon fontSize="inherit" />}
      </Link>
      <Collapse in={isExpanded} unmountOnExit>
        <Box component="ul" sx={{ m: 0, pl: 2 }}>
          {names.map((name, index) => (
            <Typography key={`${name}-${index}`} component="li" variant="caption">
              {name}
            </Typography>
          ))}
        </Box>
      </Collapse>
    </>
  );
}
